import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { GojsDiagramBlock } from '../../../model';
import { GojsDiagramViewerComponent } from '../../../gojs/gojs-diagram-viewer.component';

@Component({
  selector: 'dojo-gojs-diagram-block-renderer',
  standalone: true,
  template: `
    <dojo-gojs-diagram-viewer
      [model]="block().model"
      [layoutType]="block().layout_type ?? 'tree'"
      [height]="block().height"
      [hoverHighlight]="block().hover_highlight ?? false"
    />
  `,
  styles: `
    :host {
      @apply block my-4;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GojsDiagramViewerComponent],
})
export class GojsDiagramBlockRendererComponent {
  readonly block = input.required<GojsDiagramBlock>();
}
